module.exports = __webpack_public_path__ + "static/media/classic-xp.2429db86.png";